import useBbbConstants, {
  IDataType as IBbbConstantsDataType,
} from './useBbbConstants'
import useBbbCorporateItems, {
  IDataType as IBbbCorporateItemsDataTpye,
  IOptionType as IBbbCorporateItemsOptionType,
} from './useBbbCorporateItems'
import useBbbLocationItems, {
  IDataType as IBbbLocationItemsDataTpye,
  IOptionType as IBbbLocationItemsOptionType,
} from './useBbbLocationItems'
import useBbbLocationList, {
  IDataType as IBbbLocationListDataType,
} from './useBbbLocationList'
import useBbbPnl, {
  IDataType as IBbbPnlDataType,
  IOptionType as IBbbPnlOptionType,
} from './useBbbPnl'

export type IVariablesType =
  | 'bbbPnl'
  | ({ type: 'bbbPnl' } & IBbbPnlOptionType)
  | 'bbbLocationList'
  | 'bbbConstants'
  | ({ type: 'bbbCorporateItems' } & IBbbCorporateItemsOptionType)
  | ({ type: 'bbbLocationItems' } & IBbbLocationItemsOptionType)

export type IDataType = IBbbPnlDataType &
  IBbbLocationListDataType &
  IBbbConstantsDataType &
  IBbbCorporateItemsDataTpye &
  IBbbLocationItemsDataTpye

export const hooks = [
  ['bbbPnl', useBbbPnl],
  ['bbbLocationList', useBbbLocationList],
  ['bbbConstants', useBbbConstants],
  ['bbbCorporateItems', useBbbCorporateItems],
  ['bbbLocationItems', useBbbLocationItems],
] as const
